export enum DashboardCardType {
	ClientRevenue,
	ClientRateVsBenchmark,
	ClientPhysicalUtilization,
	ClientUtilizationVsBenchmark,
	TopQuartile,
	BottomQuartile,
	ClientDollarUtilization,
	ClientDollarUtilizationVsBenchmark
}